// extracted by mini-css-extract-plugin
export var dropdownContainer = "_bi-0";
export var leftAlign = "_bi-4";
export var listItem = "_bi-2";
export var listItemWrapper = "_bi-1";
export var operationText = "_bi-3";